export default __webpack_public_path__ + "static/media/dr-darshana.5006bcb7.jpg";